import { currentLocale } from '@web/i18n'

export function formatNumber(n: number | null | undefined): string {
  return new Intl.NumberFormat(currentLocale()).format(n ?? 0)
}

/** Date courte (« 24 oct. 2026 ») ; accepte AAAA-MM-JJ ou une date ISO complète. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return ''
  const day = value.slice(0, 10)
  const d = /^\d{4}-\d{2}-\d{2}$/.test(day) ? new Date(`${day}T12:00:00`) : new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat(currentLocale(), { day: 'numeric', month: 'short', year: 'numeric' }).format(d)
}
